import React, { useState } from "react";

import PageHeading from "../../../../../components/common/PageHeading";
import RightBar from "../../../../../components/common/RightBar";
import FormAction from "../../../../../components/common/FormAction";
import AttachmentsUpload from "../../../../../components/common/AttachmentsUpload";
import RightBarMethod from "../../../../../components/common/RightBar/RightBarMethod";

import { inches } from "../../../../../utils/letter";
import { Editor } from "react-draft-wysiwyg";
import { EditorState } from "draft-js";

import {
  Button,
  Card,
  Checkbox,
  Col,
  Form,
  Input,
  Radio,
  Row,
  Select,
  Space,
} from "antd";
import TextArea from "antd/es/input/TextArea";

import "../NewTenantLetterTemplate/NewTenantLetterTemplate.css";

const NewVendorLetterTemplateRightBar = [
  RightBarMethod("Statements", "t1", <i className="fa-solid fa-file"></i>, [
    RightBarMethod(
      "Send Owner Packets",
      "1",
      "",
      "",
      "/communication/letters_templates/send_owner_packets"
    ),
    RightBarMethod("Send Statements", "2", "", "", ""),
  ]),
];

function NewVendorLetterTemplate() {
  const [value, setValue] = useState(1);
  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty()
  );
  const onChange = (e) => {
    console.log("radio checked", e.target.value);
    setValue(e.target.value);
  };
  return (
    <>
      <div className="new-tenant-letter-template">
        <PageHeading heading="New Vendor Letter Template" />
        <Card title="Template Settings">
          <Form colon={false} labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
            <Row gutter={[0, 24]}>
              <Col span={24}>
                <Row>
                  <Col span={24}>
                    <Form.Item label="Name" required>
                      <Input placeholder="Enter Name" />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Description">
                      <TextArea rows={1} placeholder="Enter Description" />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label=" ">
                      <Checkbox>
                        Include company logo at the top of the letter
                      </Checkbox>
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="If Emailing, Send Letter As">
                      <Radio.Group onChange={onChange} value={value}>
                        <Space direction="vertical">
                          <Radio value="1">An email attachment</Radio>
                          <Radio value="2">Part of email body</Radio>
                        </Space>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Margins (inches)">
                      <Form layout="vertical">
                        <Row gutter={[8, 0]}>
                          <Col span={6}>
                            <Form.Item label="Top">
                              <Select
                                options={inches}
                                showSearch
                                allowClear
                                defaultValue="1.0"
                              />
                            </Form.Item>
                          </Col>
                          <Col span={6}>
                            <Form.Item label="Right">
                              <Select
                                options={inches}
                                showSearch
                                allowClear
                                defaultValue="1.0"
                              />
                            </Form.Item>
                          </Col>
                          <Col span={6}>
                            <Form.Item label="Bottom">
                              <Select
                                options={inches}
                                showSearch
                                allowClear
                                defaultValue="1.0"
                              />
                            </Form.Item>
                          </Col>
                          <Col span={6}>
                            <Form.Item label="Left">
                              <Select
                                options={inches}
                                showSearch
                                allowClear
                                defaultValue="1.0"
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      </Form>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              <Col span={24} className="editor">
                <Editor
                  editorState={editorState}
                  onEditorStateChange={setEditorState}
                />
              </Col>
              <Col span={24}>
                <Button>Preview</Button>
              </Col>
              <Col span={24}>
                <FormAction />
              </Col>
            </Row>
          </Form>
        </Card>
        <br />
        <Row>
          <Col span={24}>
            {/* <AttachmentsUpload info="Only PDF attachments will be included with the letter. All PDFs uploaded will be concatenated into a single PDF when the letter is sent." /> */}
          </Col>
        </Row>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={NewVendorLetterTemplateRightBar} />
      </div>
    </>
  );
}

export default NewVendorLetterTemplate;
